<template>
    <div class="family-search-header pa-flex pa-h-8 pa-w-full pa-items-center pa-justify-between pa-border-b pa-border-grey-40 pa-bg-green-40 pa-px-4 pa-text-[14px]">
        <!--标题相关信息-->
        <template>
            <!--内容-->
            <template v-if="!pageIsLoadingRoot">
                <div class="family-search-header__info pa-flex pa-shrink-0 pa-items-center">
                    <p class="pa-mr-2 pa-text-gray-90">
                        {{ pageIndex }}
                    </p>
                    <p class="pa-mr-2 pa-text-green-600">
                        {{ t(`patentFamily.${familySearchType}`) }} {{ pageCurrentActiveItem.family_id }}
                    </p>
                </div>
                <FamilySearchHeaderTitle class="pa-flex-1" />
            </template>
            <!--loading-->
            <div v-else class="pa-flex pa-h-4 pa-items-center">
                <p class="pa-radio pa-mr-2 pa-h-full pa-w-4 pa-rounded pa-bg-gray-40" />
                <p class="pa-radio pa-h-full pa-w-40 pa-rounded pa-bg-gray-40" />
            </div>
        </template>
        <!--右侧工具-->
        <template>
            <!--内容-->
            <div v-if="!pageIsLoadingRoot" class="family-search-header__function pa-ml-3 pa-flex pa-shrink-0 pa-items-center">
                <SaveToWorkspaceComplex
                    v-if="permissions.addToWorkspace && patentId && !isFamilySearchFromWorkspace && !patentInfoIsLoading"
                    :patentId="patentId"
                    :searchMode="'family'"
                    :groupMode="familySearchType"
                    :familyCount="patentInfo.patsnap_family_count"
                    class="family-search-header__function__save-workspace"
                />
                <FamilySearchHeaderToggle />
            </div>
            <!--loading-->
            <div v-else class="pa-flex pa-h-4 pa-items-center">
                <p class="pa-radio pa-mr-2 pa-h-full pa-w-20 pa-rounded pa-bg-gray-40" />
                <p class="pa-radio pa-mr-2 pa-h-full pa-w-10 pa-rounded pa-bg-gray-40" />
                <p class="pa-radio pa-h-full pa-w-20 pa-rounded pa-bg-gray-40" />
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import SaveToWorkspaceComplex from '../../views/function-bar/SaveToWorkspaceComplex.vue';
import FamilySearchHeaderTitle from './FamilySearchHeaderTitle.vue';
import FamilySearchHeaderToggle from './FamilySearchHeaderToggle.vue';
import { useFamilySearch } from '@/composables/use-family-search';
import { useFamilySearchPage } from '@/composables/use-family-search-page';
import { useFamilySearchUrlParams } from '@/composables/use-family-search-url-params';
import { useFamilySearchPatentInfo } from '@/composables/use-family-search-patent-info';
import { useI18n } from '@/composables/use-i18n';
import { usePermission } from '@/composables/use-permission';

const { permissions } = usePermission();

const { isFamilySearchFromWorkspace } = useFamilySearch();

const { isLoadingRoot: pageIsLoadingRoot, index: pageIndex, currentActiveItem: pageCurrentActiveItem } = useFamilySearchPage();
const { familySearchType } = useFamilySearchUrlParams();

const { patentInfo, isLoading: patentInfoIsLoading } = useFamilySearchPatentInfo();
const { t } = useI18n();

const patentId = computed(() => pageCurrentActiveItem.value.patent_id);
</script>

<style lang="scss">
.family-search-header__function__save-workspace {
    .elstc-btn {
        padding: 0 8px;
        height: 24px;
        line-height: 24px;
        margin-right: 12px;
        &:hover {
            background-color: rgba(179, 186, 197, 0.2);
        }
    }
    .eb-pre-text {
        display: inline-block;
        font-size: 12px;
    }
}
</style>
